import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {REGIONS} from '../../../../../constants/constants';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {Master} from '../../../../../admin/models/master.interface';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'app-additional-filters',
  templateUrl: './additional-filters.component.html',
  styleUrls: ['./additional-filters.component.scss']
})
export class AdditionalFiltersComponent implements OnInit, OnChanges {

  @ViewChild('allSelected') private allSelected!: MatOption;

  regions = REGIONS;

  @Input()
  years!: number[];
  @Input()
  categories!: Master[];

  types = ['RETAIL', 'MUNICIPAL', 'OTHER'];

  searchForm = this.formBuilder.group({
    year: [''],
    categories: [''],
    type: [],
    member: [],
    region: [''],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }

  get categoriesControl(): FormControl {
    return this.searchForm.get('categories') as FormControl;
  }

  get typeControl(): FormControl {
    return this.searchForm.get('type') as FormControl;
  }

  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  get regionControl(): FormControl {
    return this.searchForm.get('region') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.years = this.years.filter(year => year >= 2021);
    this.yearControl.setValue(this.years[0]);
    this.typeControl.setValue('RETAIL');
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  ngOnChanges(): void {
    this.years = this.years.filter(year => year >= 2021);
    if (this.categories?.length) {
      if (!this.categoriesControl.value || this.categoriesControl.value.length === this.categories.length) {
        if (this.allSelected) {
          this.allSelected.select();
        }
        this.categoriesControl
          .patchValue([...this.categories.map(item => item.id.toString()), 0]);
      }
    }
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      categories: this.categoriesControl.value,
      type: this.typeControl.value,
      member: this.memberControl.value,
      region: this.regionControl.value,
    };
    this.search.emit(search);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.typeControl.setValue('RETAIL');
    this.memberControl.reset();
    this.regionControl.reset();
    this.categoriesControl.reset();
    this.search.emit({startYear: this.years[0], type: 'RETAIL'});
  }

  togglePerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }
  }

  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.categoriesControl
        .patchValue([...this.categories.map(item => item.id.toString()), 0]);
    } else {
      this.categoriesControl.patchValue([]);
    }
  }


}
